module.exports = __webpack_public_path__ + "static/media/photo_002.05ae6169.JPG";